import styled from "styled-components";

export default styled.div`
  background: #ff5e5e;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  font-weight: 400;
  padding: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    padding: 2em;
    color: #fff;
  }
`;
